export interface IUrlParams {
  getParam(key: string): string | null
  setParam(key: string, value: string): void
  removeParam(key: string): void
}

export class UrlParamsBackend implements IUrlParams {
  constructor(private window: Window) {}

  getParam(key: string): string | null {
    const urlParams = new URLSearchParams(this.window.location.search)
    return urlParams.get(key)
  }

  setParam(key: string, value: string): void {
    const url = new URL(this.window.location.href)
    url.searchParams.set(key, value)
    this.window.history.replaceState({}, "", url.toString())
  }

  removeParam(key: string): void {
    const url = new URL(this.window.location.href)
    url.searchParams.delete(key)
    this.window.history.replaceState({}, "", url.toString())
  }
}
